import { atom } from 'recoil';

export const productSearchDialogOpenState = atom({
    key: 'productSearchDialogOpenSate',
    default: false,
});
